import React from 'react';
import ReveHimself from '../../components/icons/reve_himself';
import { useAuth, useOrgLinkBranding } from '../../contexts/AuthContext';
import { NEUTRAL_ICON_URL } from '../../utils/neutralBranding';

const ME_AVATAR_FALLBACK_ICON_PX = 27;

interface AvatarProps {
    sender: 'me' | 'other';
    agentName?: string;
    isCrossUserMessage?: boolean;
    userPictureUrl?: string;
}

const Avatar: React.FC<AvatarProps> = ({ sender, isCrossUserMessage, userPictureUrl }) => {
    const { user } = useAuth();
    const { whitelabel } = useOrgLinkBranding();

    if (sender === 'me') {
        const imageUrl = userPictureUrl || (isCrossUserMessage ? undefined : user?.backend?.picture);
        
        return (
            <div className="flex w-8 h-8 items-center gap-2.5 aspect-square">
                <div
                    className={`flex w-8 h-8 shrink-0 aspect-square rounded-full bg-no-repeat bg-center relative overflow-hidden ${imageUrl ? 'bg-cover' : 'bg-hex-gray-200'}`}
                    style={imageUrl ? { backgroundImage: `url(${imageUrl})` } : undefined}
                >
                    {!imageUrl && (
                        <span className="absolute inset-0 flex items-center justify-center pointer-events-none text-hex-gray-500">
                            <svg
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                aria-hidden
                                className="block shrink-0"
                                style={{
                                    width: ME_AVATAR_FALLBACK_ICON_PX,
                                    height: ME_AVATAR_FALLBACK_ICON_PX,
                                }}
                            >
                                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                            </svg>
                        </span>
                    )}
                    <div className="absolute inset-0 rounded-full border-[0.50px] border-chat-border opacity-30 pointer-events-none" />
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center gap-1">
            <div className="flex w-8 h-8 items-center justify-center">
                {whitelabel ? <img src={NEUTRAL_ICON_URL} alt="" className="w-8 h-8" /> : <ReveHimself />}
            </div>
      
        </div>
    );
};

export default Avatar;
